// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1BpOo","label":"CategoryService_label__36kkt","location":"CategoryService_location__mLXQj"};